import React from 'react';

export default function AIAssistantWidget() {
  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200 w-full max-w-2xl">
      {/* Content */}
      <div className="p-6 flex flex-col h-[500px]">
        {/* Question Header */}
        <div className="bg-gradient-to-r from-slate-700 to-slate-600 text-white p-4 rounded-lg mb-6 flex items-start justify-between flex-shrink-0">
          <span className="text-base leading-relaxed">Where are we off-track against this quarter's goals — and what are the top drivers?</span>
          <span className="text-xl ml-2">⋯</span>
        </div>
        
        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-scroll scrollbar-visible mb-6 pr-2">
          {/* Summary */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Summary</h3>
            <p className="text-gray-700 mb-4">You're off-track on 2 of 4 quarterly goals. The gap is concentrated in Pipeline Coverage and On-time Delivery.</p>
          </div>
          
          {/* Where we're off-track */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Where we're off-track</h3>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <span className="text-yellow-500">●</span>
                <p className="text-gray-700"><span className="font-semibold">Pipeline Coverage:</span> 2.3x vs 3.0x target (-0.7x)</p>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-yellow-500">●</span>
                <p className="text-gray-700"><span className="font-semibold">On-time Delivery:</span> 78% vs 90% target (-12 pts)</p>
              </div>
            </div>
          </div>
          
          {/* Top drivers */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Top drivers <span className="text-gray-500 font-normal text-sm">(ranked)</span></h3>
            <div className="space-y-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold text-gray-800 mb-2">1. Top-of-funnel volume down (-14%)</p>
                <p className="text-sm text-gray-600">Driven by reduced spend in two channels and slower MQL → SQL conversion (22% → 17%).</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold text-gray-800 mb-2">2. Customer escalations consuming delivery capacity</p>
                <p className="text-sm text-gray-600">Escalation-related work increased to 18% of sprint capacity (was 10%).</p>
              </div>
            </div>
          </div>
          
          {/* Recommended actions */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Recommended actions <span className="text-gray-500 font-normal text-sm">(this week)</span></h3>
            <div className="space-y-2">
              <div className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600">📊</span>
                <p>Qx OKR Dashboard → Goals vs Actuals (updated 2d ago)</p>
              </div>
              <div className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600">📝</span>
                <p>Weekly Revenue Report → Pipeline Coverage + Conversion</p>
              </div>
              <div className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600">🎯</span>
                <p>Delivery Metrics → Cycle Time + On-time Delivery</p>
              </div>
              <div className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600">☰</span>
                <p>Escalations Tracker → Capacity Impact</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Action Buttons - Fixed */}
        <div className="flex gap-3 flex-shrink-0">
          <button className="bg-slate-700 text-white px-4 py-2.5 rounded-lg font-medium text-sm cursor-default">
            Draft Exec Update
          </button>
          <button className="bg-gray-200 text-gray-800 px-4 py-2.5 rounded-lg font-medium text-sm cursor-default">
            Create Action Plan
          </button>
          <button className="bg-gray-200 text-gray-800 px-4 py-2.5 rounded-lg font-medium text-sm cursor-default">
            Open Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
